import template from './onboardingAuthorityAndConsent.html';
import OnboardingAuthorityAndConsentCtrl from './onboardingAuthorityAndConsentCtrl';

export default {
  template,
  controller: OnboardingAuthorityAndConsentCtrl,
  controllerAs: 'vm',
  bindings: {
    familyId: '<',
    onTick: '&',
  },
};
